import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/sharp-solid-svg-icons';
import { getDataTestId } from 'eone-ui/functions/data-test-ids';
import './tab_group_editable.css';

interface SCTabGroupEditableTab {
  Value: string;
  Label: string;
  Closable?: boolean;
  HasError?: boolean;
}

interface SCTabGroupEditableProps {
  Tabs: SCTabGroupEditableTab[];
  Value: string;
  OnChange: (value: string) => void;
  OnClose?: (value: string) => void;
  OnAdd?: () => void;
  AddLabel?: string;
  CanAdd?: boolean;
  AddDisabledTitle?: string;
  DataTestId?: string;
}

function SCTabGroupEditable({
  Tabs,
  Value,
  OnChange,
  OnClose,
  OnAdd,
  AddLabel = '+ Add child',
  CanAdd = true,
  AddDisabledTitle,
  DataTestId,
}: SCTabGroupEditableProps) {
  return (
    <div className="sce-tab-group-editable" data-testid={DataTestId}>
      {Tabs.map((tab) => (
        <button
          key={tab.Value}
          type="button"
          data-testid={getDataTestId(DataTestId, tab.Value)}
          className={
            'sce-tge-tab' +
            (tab.Value === Value ? ' active' : '') +
            (tab.HasError ? ' has-error' : '')
          }
          onClick={() => OnChange(tab.Value)}
        >
          <span>{tab.Label}</span>
          {tab.HasError && (
            <span className="sce-tge-error-badge" aria-hidden="true">
              <FontAwesomeIcon icon={faExclamationTriangle} />
            </span>
          )}
          {tab.Closable && OnClose && (
            <span
              className="sce-tge-close"
              data-testid={getDataTestId(DataTestId, tab.Value, 'close')}
              onClick={(e) => {
                e.stopPropagation();
                OnClose(tab.Value);
              }}
              title="Remove this level (and any below)"
            >
              ×
            </span>
          )}
        </button>
      ))}
      {OnAdd && (
        <button
          type="button"
          className="sce-tge-add"
          data-testid={getDataTestId(DataTestId, 'add')}
          onClick={OnAdd}
          disabled={!CanAdd}
          title={!CanAdd ? AddDisabledTitle : undefined}
        >
          {AddLabel}
        </button>
      )}
    </div>
  );
}

export { SCTabGroupEditable };
export type { SCTabGroupEditableProps, SCTabGroupEditableTab };
